import React from "react";
import { Input as UncontrolledInput } from "../../../../../components/input/input";
import { PrefillInput as ControlledInput } from "../../../../../components/input";
import { NumberInput } from "./numberInput";

export const MoneyInput = React.forwardRef(({
  onBlur, name, title, className, value, onChange, errorMessage, customFieldUpdater, decimalPlaces, disabled
}, ref) => {
  const InputType = !!value ? UncontrolledInput : ControlledInput;

  return (
    <InputType
      ref={ref}
      disabled={disabled}
      className={className}
      onBlur={onBlur}
      title={title}
      onChange={onChange}
      value={value}
      name={name}
      maxLength={5}
      prefix={() => (<>$</>)}
      errorMessage={errorMessage}
      inputRender={(inputProps) => (
        <NumberInput {...inputProps} customFieldUpdater={customFieldUpdater} decimalPlaces={decimalPlaces} />
      )}
    />
  );
});